// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/symbol.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/v1/symbol.proto.
 */
export const file_vitesse_v1_symbol = /*@__PURE__*/ fileDesc("Chd2aXRlc3NlL3YxL3N5bWJvbC5wcm90bxIKdml0ZXNzZS52MSKkAQoQU3ltYm9sRGVzY3JpcHRvchIRCglkYXRhX3R5cGUYASABKAkSEgoKcGVybWlzc2lvbhgCIAEoCRIMCgR1bml0GAMgASgJEhAKCHByaW9yaXR5GAUgASgIEg4KBmxvY2tlZBgGIAEoCBIRCglkZWxldGFibGUYByABKAgSEwoLZW51bV92YWx1ZXMYCCADKAlKBAgEEAVSC2Rlc2NyaXB0aW9uIqEBCgtTeW1ib2xWYWx1ZRISCghib29sX3ZhbBgBIAEoCEgAEhEKB2ludF92YWwYAiABKANIABISCghyZWFsX3ZhbBgDIAEoAUgAEhQKCnN0cmluZ192YWwYBCABKAlIABIRCgdyYXdfdmFsGAUgASgMSAASDwoHcXVhbGl0eRgGIAEoDRIUCgx0aW1lc3RhbXBfbnMYByABKANCBwoFdmFsdWUiGgoJVXNlckxhYmVsEg0KBWxhYmVsGAEgASgJQrABCg5jb20udml0ZXNzZS52MUILU3ltYm9sUHJvdG9QAVpIZ2l0aHViLmNvbS9Nb3ZlbmRpLWFpL3ZpdGVzc2UtcGxhdGZvcm0vcHJvdG8vZ2VuL2dvL3ZpdGVzc2UvdjE7dml0ZXNzZXYxogIDVlhYqgIKVml0ZXNzZS5WMcoCClZpdGVzc2VcVjHiAhZWaXRlc3NlXFYxXEdQQk1ldGFkYXRh6gILVml0ZXNzZTo6VjFiBnByb3RvMw");
/**
 * Describes the message vitesse.v1.SymbolDescriptor.
 * Use `create(SymbolDescriptorSchema)` to create a new message.
 */
export const SymbolDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol, 0);
/**
 * Describes the message vitesse.v1.SymbolValue.
 * Use `create(SymbolValueSchema)` to create a new message.
 */
export const SymbolValueSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol, 1);
/**
 * Describes the message vitesse.v1.UserLabel.
 * Use `create(UserLabelSchema)` to create a new message.
 */
export const UserLabelSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_symbol, 2);
//# sourceMappingURL=symbol_pb.js.map